module.exports = __webpack_public_path__ + "img/f381b3cdd4704312a0d2fdb12bbba661-1024.875ed5b1.jpg";